import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'
import Footer from '../_shared/Footer'
import Sidebar from '../_shared/Sidebar'
import { useFetchNavigationStyle, useSyncApiState } from './hooks'
import Placement from './Placement'
import StyleSection from './StyleSection'

const t = buildTranslate('cms.content.app_navigation.style')

const Style: React.FC = () => {
  // Load back-end API data (ideally just on mount)
  useFetchNavigationStyle()

  // Sync the local state with the API state
  useSyncApiState()

  return (
    <CmsPage
      title={t('title')}
      description={t('description')}
      sidebar={<Sidebar />}
    >
      <div className={'p-m white-bkg mb-l'}>
        <Placement />
        <StyleSection />
      </div>
      <Footer />
    </CmsPage>
  )
}

export default Style
